import React from "react";
import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { Loader } from "../../../../../components/Loader/Loader";
import { format } from "date-fns";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function ReceiptACYear() {
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { RecReceiptAcYeardata } = useSelector(
    (state) => state.ReceivablePaybleSlice,
  );

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;

  const getPercent = (value, total) => {
    if (!value || !total || total === 0) return "0%";
    return `${((value / total) * 100).toFixed(2)}%`;
  };

  const getRows = RecReceiptAcYeardata?.Detail?.map((label, index) => ({
    chart: true,
    srNumber: index + 1,
    Month: label.Month,
    ProductionGroupMstName: label.ProductionGroupMstName,
    AcName: label.AcName,
    BalanceAmt: label.BalanceAmt,
    OvrBalanceAmt: label.OvrBalanceAmt,
    OverDuePer: label.OverDuePer,
    PaymentTerms: label.PaymentTerms,
    OverDueDays: label.OverDueDays,
    TurnOverDays: label.TurnOverDays,
    TotalSale: label.TotalSale,
    TotalReceipt: label.TotalReceipt,
    DaysLastReceipt: label.DaysLastReceipt,
    DaysAfterLastDate: label.DaysAfterLastDate,
  }));




  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "ProductionGroupMst Name",
      key: "ProductionGroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Month Name",
      key: "Month",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Receivable Balance",
      key: "BalanceAmt",
      align: "right",
      format: "true",
    },
    {
      label: "Receivable OvrBalance",
      key: "OvrBalanceAmt",
      align: "right",
      format: "true",
    },
    {
      label: "Receivable OverDuePer",
      key: "OverDuePer",
      align: "right",
      format: "true",
    },
    { label: "Payment Terms", key: "PaymentTerms", align: "right" },
    { label: "OverDue Days", key: "OverDueDays", align: "right" },
    { label: "TurnOver Days", key: "TurnOverDays", align: "right" },
    { label: "Total Sale", key: "TotalSale", align: "right", format: "true " },
    {
      label: "Total Receipt",
      key: "TotalReceipt",
      align: "right",
      format: "true ",
    },
    { label: "Days Last Receipt", key: "DaysLastReceipt", align: "right" },
    { label: "Days sinc Last sales", key: "DaysAfterLastDate", align: "right" },
  ];

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(amount || 0));
  };

  const calculateTotal = (key) => {
    if (!RecReceiptAcYeardata?.Detail || !Array.isArray(RecReceiptAcYeardata.Detail)) return 0;
    return RecReceiptAcYeardata.Detail.reduce((sum, item) => sum + (Number(item[key]) || 0), 0);
  };

  const receiptYearData = [
    {
      title: "BALANCE",
      value: calculateTotal("BalanceAmt"),
    },
    {
      title: "OVERDUE",
      value: calculateTotal("OvrBalanceAmt"),
    },
    {
      title: "OVERDUE %",
      value: calculateTotal("OverDuePer"),
    },
    {
      title: "TURNOVER DAYS",
      value: calculateTotal("TurnOverDays"),
    },
    {
      title: "TOTAL SALES",
      value: calculateTotal("TotalSale"),
    },
    {
      title: "TOTAL RECEIPT",
      value: calculateTotal("TotalReceipt"),
    },
  ];

  const cardStyle = {
    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
    border: `1px solid ${isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
      }`,
    borderLeft: `6px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10
      }`,
    borderRadius: "12px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "100%",
  };

  const titleStyle = {
    color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
    fontWeight: "600",
  };

  const subtitleStyle = {
    marginTop: "10px",
    fontWeight: "500",
    color: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10,
  };

  if (RecReceiptAcYeardata === "no" || RecReceiptAcYeardata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div>
      <Row className="g-3">
        {receiptYearData.map((item, index) => (
          <Col
            key={index}
            xl={2}
            lg={4}
            md={4}
            sm={6}
            xs={12}
            className="quarter-box"
          >
            <div style={cardStyle}>
              <h6 style={subtitleStyle}>
                {item.title === "OVERDUE %" || item.title === "TURNOVER DAYS"
                  ? Number(item.value || 0).toFixed(2)
                  : formatAmount(item.value)}
              </h6>
              <p style={titleStyle}>{item.title}</p>
            </div>
          </Col>
        ))}
      </Row>

      <div style={{ marginTop: "20px" }}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              padding: "14px",
              margin: 0,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              RECEIPT YEAR
            </h2>
          </div>
          <FASTable data={getRows} columns={getColumns} />
        </div>
      </div>
    </div>
  );
}
